import { useContext } from 'react';
import {
  EmployeeFormContext,
  EmployeeFormContextType,
} from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/EmployeeFormContext';

export const useEmployeeFormContext = (): EmployeeFormContextType => {
  const context = useContext(EmployeeFormContext);
  if (!context) {
    throw new Error(
      'useEmployeeFormContext must be used within an EmployeeFormProvider'
    );
  }
  return context;
};
